module.exports = __webpack_public_path__ + "static/media/uploadSvgDark.c19738f2.svg";